import React, { useState } from "react";
import {
  Container, Title, Text, Box, Group, Accordion,
  Badge, Button, Stack, rem,
} from "@mantine/core";
import { IconBrandWhatsapp, IconArrowLeft } from "@tabler/icons";
import METATAGSEO from "@/components/metaTagSEO";
import JsonLd from "@/components/JsonLd";
import { siteConfig } from "@/components/seoConfig";
import Link from "next/link";
import classes from "../styles/FAQ.module.css";

// ─── נתונים ───────────────────────────────────────────────────
const FAQ_CATEGORIES = [
  {
    id: "pricing", label: "💰 מחיר ותשלום", questions: [
      { q: "כמה עולה QuickTor?", a: "QuickTor עולה 99₪ לחודש בלבד. אין דמי הקמה, אין חוזה ואין התחייבות לתקופה מינימלית. ניתן לבטל בכל עת." },
      { q: "האם יש תקופת ניסיון חינם?", a: "כן! 14 ימי ניסיון חינם מלא. בסיום הניסיון המנוי ממשיך אוטומטית ב-99₪ לחודש. לא מתאים לך? מבטלים לפני סוף הניסיון ולא משלמים כלום." },
      { q: "האם אפשר לבטל מנוי בכל עת?", a: "כן, ניתן לבטל את המנוי בכל עת ישירות מהגדרות החשבון. אין קנסות ביטול ולא תחויבו לאחר הביטול." },
      { q: "מה ההבדל בין QuickTor לתוכנת תורים בחינם?", a: "תוכנות חינמיות מוגבלות  מספר תורים, פרסומות, ואין תמיכה. QuickTor ב-99₪ נותנת ניהול תורים מלא + תזכורות ווטסאפ + גביית תשלומים + והכי חשוב שירות שזמין עבורכם לכל דבר, החל מתמיכה טכנית ועד פיתוח פיצ׳רים מותאמים אישית + דף עסקי ממותג  הכל ללא הגבלה." },
      { q: "מהי מערכת ניהול התורים המשתלמת ביותר שכוללת וואטסאפ ללא הגבלה?", a: "מערכת QuickTor מציעה חבילת \"הכל כלול\" ב-99 ש\"ח בלבד הכוללת תזכורות ועדכונים על תורים ב-WhatsApp ללא הגבלה." },
    ],
  },
  {
    id: "features", label: "⚡ פיצ׳רים", questions: [
      { q: "איך הלקוחות קובעים תור דרך QuickTor?", a: "בעל העסק מקבל דף עסקי ממותג עם URL ייחודי. הלקוח בוחר שירות, תאריך ושעה  ומקבל אישור אוטומטי לווטסאפ. 24/7, ללא שיחת טלפון." },
      { q: "האם אפשר לשלוח תזכורות בווטסאפ?", a: "כן, זה אחד הפיצ׳רים המרכזיים. המערכת שולחת תזכורות ווטסאפ אוטומטיות לפני התור עם שעה, שירות ופרטי העסק." },
      { q: "כמה תזכורות וואטסאפ מורידות הברזות?", a: "לפי מטא-אנליזה של 16 מחקרים (BMJ Open, 2016), תזכורת דיגיטלית לפני התור מורידה את שיעור ההברזות מ-21% ל-15%, כלומר בכ-25%. 99% מהישראלים משתמשים בוואטסאפ (איגוד האינטרנט הישראלי, 2025). לפי נתוני סלונים של Phorest, מקדמה בקביעת התור מורידה הברזות עד 69%. הפירוט המלא בעמוד סטטיסטיקות ההברזות באתר." },
      { q: "האם אפשר לגבות תשלום מראש?", a: "כן. ניתן לדרוש תשלום מלא או מקדמה מראש. הכסף נכנס לחשבונך דרך מערכת סליקה מאובטחת. לקוח שמשלם מראש כמעט אף פעם לא מבטל. על סליקה דרך המערכת חלות עמלות סליקה, שאינן כלולות במחיר של 99₪ לחודש." },
      { q: "האם אפשר לנהל כמה עובדים?", a: "כן. QuickTor מאפשר הוספת עובדים עם יומנים נפרדים, שירותים ומחירים ייחודיים, ותצוגת מנהל הכוללת מעקב אחר מכירות וקביעת תורים של העובדים." },
      { q: "האם יש דף עסקי שמקדם אותי בגוגל?", a: "כן. כל עסק מקבל דף עסקי ממותג עם URL ייחודי שמוצג במנועי חיפוש  כולל תמונות, שירותים, מחירים ויומן פעיל." },
      { q: "האם יש ניהול סדרות טיפולים?", a: "כן. המערכת מנהלת סדרות טיפולים (כמו 5 טיפולי פנים ברצף), מציגה את ההתקדמות ומתריעה על סיומה." },
      { q: "האם יש דוחות ביצועים?", a: "כן. לוח בקרה עם נתוני הכנסות, מספר תורים, אחוזי הגעה ולקוחות חדשים  לפי יום, שבוע או חודש." },
      { q: "איך קוסמטיקאיות ונייליסטיות יכולות למלא חורים ביומן באופן אוטומטי?", a: "באמצעות רשימת ההמתנה החכמה של QuickTor, ברגע שתור מתבטל, המערכת מאתרת אוטומטית לקוחה מתאימה מרשימת ההמתנה ושולחת לה הודעה מיידית למילוי החור." },
    ],
  },
  {
    id: "getting_started", label: "🚀 התחלה", questions: [
      { q: "כמה זמן לוקח להתחיל ב-QuickTor?", a: "הרשמה נמשכת פחות מ-5 דקות. תוך שעה אפשר להגדיר שירותים, שעות, מחירים ועובדים  ולהתחיל לקבל תורים." },
      { q: "איך מעבירים לקוחות מיומן רגיל לדיגיטלי?", a: "שולחים ללקוחות הקיימים את הלינק לדף העסקי ומבקשים שיקבעו ממנה ואילך בעצמם. QuickTor מספקת הדרכה אישית לכל לקוח חדש." },
      { q: "האם צריך להוריד אפליקציה?", a: "לא חובה. QuickTor נגישה מכל מקום ופועלת במלואה דרך הדפדפן בטלפון או במחשב, אך למי שמעוניין ישנה אפשרות מלאה להורדת האפליקציה מחנויות האפליקציות לגישה מהירה עוד יותר." },
      { q: "האם יש הדרכה אישית?", a: "כן, כל לקוח חדש מקבל הדרכה אישית חינמית בווטסאפ. הצוות שלנו זמין לעזור בהגדרות ראשוניות ובכל שאלה." },
      { q: "האם יש תמיכה טכנית?", a: "כן. תמיכה זמינה בווטסאפ ובמייל. זמן תגובה ממוצע  פחות משעה בשעות העסק." },
    ],
  },
  {
    id: "digital_forms", label: "📋 טפסים דיגיטליים", questions: [
      { q: "מה זה טפסים דיגיטליים ב-QuickTor?", a: "QuickTor מאפשרת לבנות טפסים דיגיטליים מותאמים אישית — הצהרות בריאות, שאלוני קבלה, טפסי הסכמה ועוד. הלקוח ממלא הכל ישירות במערכת, בלי ניירות ובלי PDF שצריך לסרוק." },
      { q: "האם אפשר לקבל חתימה דיגיטלית על טפסים?", a: "כן! זה אחד הפיצ'רים הייחודיים ביותר. הלקוח חותם ישירות על המסך — חתימה דיגיטלית מאובטחת ומשפטית — שנשמרת אוטומטית במערכת לצד הטופס שמילא." },
      { q: "אילו סוגי שאלות אפשר להוסיף לטופס?", a: "כל סוגי השאלות: שאלות אמריקאיות (כן/לא), בחירה מרובה (מספר תשובות אפשריות), טקסט חופשי, תאריך, ועוד. ניתן גם לסמן שדות כחובה ושדות כאופציונאליים לפי הצורך." },
      { q: "מה הפיצ'ר הכי מטורף בבניית טפסים?", a: "הדבקה מטופס קיים. אם כבר יש לכם הצהרת בריאות ב-Word, PDF או Excel, מעתיקים את הטקסט ומדביקים במערכת, והיא בונה ממנו את הטופס הדיגיטלי: שורות עם ☐ הופכות לאפשרויות בחירה, שורות עם ____ הופכות לשדות טקסט, ומשפטי הצהרה מסומנים כחובה. בלי לבנות שאלה שאלה ידנית." },
      { q: "האם הטפסים נשמרים אצל הלקוח בהיסטוריה?", a: "כן. כל טופס שלקוח מילא וחתם נשמר בתיק הלקוח שלו במערכת, כך שתמיד יש לכם גישה לכל ההצהרות וההיסטוריה — לפי תאריך ולפי סוג טופס." },
      { q: "האם ניתן לשלוח טופס ללקוח לפני הטיפול?", a: "כן. ניתן לשלוח את הטופס ללקוח בהודעת ווטסאפ לפני הגעתו, כך שהוא ממלא ממנו את ההצהרה מבית והגעה לטיפול חלקה יותר — חוסכים זמן יקר בתחילת הפגישה." },
    ],
  },
  {
    id: "technical", label: "🔧 טכני", questions: [
      { q: "באיזה מכשירים אפשר להשתמש?", a: "QuickTor עובדת מכל מכשיר עם דפדפן  אייפון, אנדרואיד, טאבלט ומחשב. הממשק מותאם לגמרי לכל גודל מסך." },
      { q: "האם המערכת מאובטחת?", a: "כן. כל הנתונים מאוחסנים בשרתים מאובטחים עם הצפנה מלאה. מידע על לקוחות ותשלומים מוגן לפי תקני אבטחה מחמירים." },
      { q: "האם יש אפליקציית מובייל?", a: "כן! QuickTor זמינה גם כאפליקציה להורדה מחנויות האפליקציות (App Store ו-Google Play) וגם כ-Web App מתקדמת לנייד שניתן להוסיף למסך הבית ללא הורדה." },
    ],
  },
  {
    id: "comparison", label: "🆚 השוואות", questions: [
      { q: "מה ההבדל בין QuickTor לגוגל קלנדר?", a: "גוגל קלנדר הוא יומן בסיסי  אין גביית תשלומים, תזכורות ווטסאפ, דף עסקי, ניהול לקוחות או דוחות. QuickTor היא מערכת ניהול עסק שלמה." },
      { q: "מה היתרון של QuickTor על פני מערכות בינלאומיות?", a: "מערכות בינלאומיות לא תמיד מתאימות לקהל שלנו. QuickTor פותחה מראש עבור עסקים ישראליים בדגש על תחום הביוטי, ממשק נוח וקליל בעברית, סליקת אשראי והפקת חשבוניות כחוק, ותזכורות אוטומטיות בוואטסאפ." },
      { q: "למה לא להשתמש בפנקס?", a: "פנקס לא שולח תזכורות, לא גובה מקדמה, לא מנהל היסטוריית לקוחות ולא נותן דוחות. כשלקוח מבטל ברגע האחרון  הפסדת. QuickTor פותרת את כל זה אוטומטית." },
    ],
  },
  {
    id: "professions", label: "📋 מקצועות", questions: [
      { q: "האם QuickTor מתאים למספרה?", a: "כן. מותאם לברבר עצמאי ולמספרה עם מספר ספרים. ניתן להגדיר שירותים שונים (תספורת, זקן, צביעה) ולאפשר ללקוחות לקבוע לספר הספציפי שהם מעדיפים." },
      { q: "האם QuickTor מתאים לקוסמטיקאית?", a: "כן. QuickTor נבנתה במיוחד לקוסמטיקאיות. המערכת תומכת בסדרות טיפולים, תזכורות לפני ואחרי טיפול ותשלום מראש למניעת ביטולים." },
      { q: "האם QuickTor מתאים למכון יופי עם כמה עובדות?", a: "כן. כל עובדת מקבלת יומן נפרד, וכל התורים, המלאי והדוחות של המכון מרוכזים במקום אחד. המחיר הוא 99₪ לחודש לכל המכון, בלי תוספת על עובדות." },
      { q: "האם QuickTor מתאים לנייליסטיות?", a: "כן. ניתן להגדיר שירותים שונים (ג׳ל, אקריל, עיצוב) עם משכי זמן ומחירים שונים, לנהל דף עסקי ממותג ולשלוח תזכורות ווטסאפ ללקוחות." },
      { q: "האם QuickTor מתאים למטפלים?", a: "כן. QuickTor מתאימה לכל מטפל עצמאי — רפלקסולוג, מעסה, נטורופת. המערכת מאפשרת ניהול יומן, שירותים מרובים ושמירת פרטי לקוח לטיפולים חוזרים." },
    ],
  },
];

const buildFaqSchema = () => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQ_CATEGORIES.flatMap((cat) =>
    cat.questions.map((q) => ({
      "@type": "Question",
      name: q.q,
      acceptedAnswer: { "@type": "Answer", text: q.a },
    }))
  ),
});

const BreadcrumbListJson = [
  { "@type": "ListItem", item: `${siteConfig.baseUrl}/`, name: "דף הבית", position: 1 },
  { "@type": "ListItem", item: `${siteConfig.baseUrl}/faq`, name: "שאלות נפוצות", position: 2 },
];

export default function FAQPage() {
  const [activeCategory, setActiveCategory] = useState("pricing");
  const currentCat = FAQ_CATEGORIES.find((c) => c.id === activeCategory) || FAQ_CATEGORIES[0];

  const seoData = {
    title: "שאלות נפוצות על ניהול תורים לעסק שלך | QuickTor",
    description: "כל התשובות על QuickTor — מחיר, פיצ׳רים, התחלה, השוואות ומקצועות ספציפיים. מערכת ניהול תורים ב-99₪ עם 14 ימי ניסיון חינם.",
    canonicalUrl: `${siteConfig.baseUrl}/faq`,
    OgImageUrl: `${siteConfig.baseUrl}/sectionmainpage.webp`,
    altText: "שאלות נפוצות על QuickTor — מערכת ניהול תורים",
    keywords: "שאלות נפוצות ניהול תורים, כמה עולה מערכת ניהול תורים, QuickTor שאלות, FAQ ניהול תורים",
    isPartOf: "https://quicktor.co.il/",
  };

  const totalQ = FAQ_CATEGORIES.reduce((s, c) => s + c.questions.length, 0);

  return (
    <Box style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
      <METATAGSEO {...seoData} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(buildFaqSchema()) }}
      />
      <JsonLd
        canonical="https://quicktor.co.il/faq"
        title={seoData.title}
        description={seoData.description}
        OgImageUrl={seoData.OgImageUrl}
        isPartOf="https://quicktor.co.il/"
        BreadcrumbListJson={BreadcrumbListJson}
      />

      {/* ── Hero ── */}
      <Box className={classes.hero}>
        <Container size="lg" ta="center" style={{ position: "relative", zIndex: 1 }}>
          {/* Breadcrumb */}
          <Group justify="center" mb="lg" gap={8}>
            <Link href="/" style={{ color: "rgba(255,255,255,0.75)", fontSize: 14, textDecoration: "none" }}>
              דף הבית
            </Link>
            <Text c="rgba(255,255,255,0.5)" size="sm">{"/"}</Text>
            <Text c="white" size="sm" fw={600}>שאלות נפוצות</Text>
          </Group>

          <Title order={1} className={classes.heroTitle} mb="md">
            כל השאלות על{" "}
            <Text span inherit style={{ color: "rgba(255,255,255,0.85)", textDecoration: "underline", textDecorationColor: "rgba(255,255,255,0.4)" }}>
              ניהול תורים לעסק שלך
            </Text>
          </Title>

          <Text size="xl" c="rgba(255,255,255,0.9)" maw={580} mx="auto" mb="xl" fw={400} style={{ lineHeight: 1.6 }}>
            מחיר, פיצ׳רים, איך מתחילים והשוואות — הכל כאן, בלי לחפש.
          </Text>

          <Group justify="center" gap="sm" wrap="wrap">
            <span className={classes.heroBadge}>✅ {totalQ} שאלות ותשובות</span>
            <span className={classes.heroBadge}>⚡ 14 יום ניסיון חינם</span>
            <span className={classes.heroBadge}>📞 תמיכה בווטסאפ</span>
          </Group>
        </Container>
      </Box>

      {/* ── Category Tabs ── */}
      <Container size="lg">
        <div className={classes.tabsWrapper} role="tablist" aria-label="קטגוריות שאלות">
          {FAQ_CATEGORIES.map((cat) => (
            <button
              key={cat.id}
              role="tab"
              aria-selected={activeCategory === cat.id}
              className={`${classes.tabBtn} ${activeCategory === cat.id ? classes.tabBtnActive : ""}`}
              onClick={() => setActiveCategory(cat.id)}
            >
              {cat.label}
              <Badge
                size="xs"
                variant={activeCategory === cat.id ? "white" : "light"}
                color={activeCategory === cat.id ? "gray" : "violet"}
                style={{ fontWeight: 700 }}
              >
                {cat.questions.length}
              </Badge>
            </button>
          ))}
        </div>
      </Container>

      {/* ── Main Content ── */}
      <Container size="lg" pb={80}>
        <Box style={{ display: "flex", gap: 32, alignItems: "flex-start" }}>

          {/* ── Accordion ── */}
          <Box style={{ flex: 1, minWidth: 0 }}>
            <Group mb="md" align="baseline" gap="xs">
              <Title order={2} size="h3" style={{ color: "#1a1a2e" }}>
                {currentCat.label}
              </Title>
              <Text c="dimmed" size="sm">— {currentCat.questions.length} שאלות</Text>
            </Group>

            {/* כל הקטגוריות נשארות ב-HTML (קטגוריה לא פעילה מוסתרת) — כדי שכל 34 התשובות יהיו גלויות לסורקים ויתאימו ל-FAQPage */}
            {FAQ_CATEGORIES.map((cat) => (
            <Accordion
              key={cat.id}
              hidden={cat.id !== currentCat.id}
              variant="separated"
              radius="md"
              styles={{
                item: {
                  backgroundColor: "white",
                  border: "1px solid #e9ecef",
                  borderRadius: "14px !important",
                  marginBottom: 10,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                  transition: "all 0.25s ease",
                  overflow: "hidden",
                },
                control: {
                  fontWeight: 700,
                  fontSize: "1rem",
                  color: "#1a1a2e",
                  padding: "18px 20px",
                  "&:hover": { backgroundColor: "#f8f9ff" },
                },
                label: { color: "#1a1a2e", fontWeight: 700 },
                panel: { color: "#555", fontSize: "0.975rem", lineHeight: 1.75 },
                chevron: { color: "#764ba2" },
              }}
            >
              {cat.questions.map((item, idx) => (
                <Accordion.Item key={idx} value={`${cat.id}-${idx}`}>
                  <Accordion.Control>{item.q}</Accordion.Control>
                  <Accordion.Panel>
                    <Text size="md" style={{ lineHeight: 1.75, color: "#444", paddingTop: 4 }}>
                      {item.a}
                    </Text>
                  </Accordion.Panel>
                </Accordion.Item>
              ))}
            </Accordion>
            ))}

            {/* Internal Links */}
            <Box className={classes.linksBox}>
              <Text fw={700} mb="md" style={{ color: "#1a1a2e", fontSize: "1rem" }}>
                📚 מאמרים שיעזרו לך
              </Text>
              <Stack gap={0}>
                {[
                  { href: "/blog/quicktor-vs-google-calendar", label: "למה לעבור מגוגל קלנדר למערכת מקצועית?" },
                  { href: "/blog/improve-appointment-show-rates-with-reminders", label: "איך לשפר אחוזי הגעה עם תזכורות אוטומטיות" },
                  { href: "/blog/5-steps-high-profits-zero-cancellations", label: "5 צעדים להכנסה מקסימלית ואפס ביטולים" },
                  { href: "/no-show-statistics", label: "סטטיסטיקות הברזות: כמה תזכורת ומקדמה מורידות" },
                  { href: "/beauty-salon-management", label: "מערכת לניהול מכון יופי" },
                  { href: "/pricing", label: "→ ראה תוכניות מחיר מפורטות" },
                ].map((link) => (
                  <Link key={link.href} href={link.href} className={classes.internalLink}>
                    {link.label}
                  </Link>
                ))}
              </Stack>
            </Box>
          </Box>

          {/* ── Sidebar (desktop only) ── */}
          <Box
            style={{
              width: 260,
              flexShrink: 0,
              position: "sticky",
              top: 90,
              display: "none",
            }}
            visibleFrom="md"
          >
            {/* Quick nav */}
            <Box mb="xl">
              <Text fw={700} mb="sm" size="sm" c="dimmed" tt="uppercase" ls={0.5}>
                קטגוריות
              </Text>
              <Stack gap={6}>
                {FAQ_CATEGORIES.map((cat) => (
                  <Button
                    key={cat.id}
                    variant={activeCategory === cat.id ? "filled" : "subtle"}
                    color="violet"
                    justify="flex-start"
                    size="sm"
                    radius="xl"
                    onClick={() => setActiveCategory(cat.id)}
                    style={{
                      fontWeight: activeCategory === cat.id ? 700 : 500,
                      fontSize: "0.875rem",
                    }}
                  >
                    {cat.label}
                  </Button>
                ))}
              </Stack>
            </Box>

            {/* CTA */}
            <Box className={classes.ctaCard}>
              <Text fw={700} mb={6} style={{ color: "#1a1a2e" }}>עדיין יש שאלות?</Text>
              <Text size="sm" c="dimmed" mb="md">הצוות שלנו זמין בווטסאפ</Text>
              <Button
                component="a"
                href="https://wa.me/972557259188?text=שלום, יש לי שאלה על QuickTor"
                target="_blank"
                rel="noopener noreferrer"
                size="sm"
                radius="xl"
                leftSection={<IconBrandWhatsapp size={16} />}
                fullWidth
                style={{
                  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  border: "none",
                }}
              >
                שאל אותנו
              </Button>
            </Box>
          </Box>
        </Box>

        {/* ── Bottom CTA ── */}
        <Box className={classes.bottomCta}>
          <Box style={{ position: "relative", zIndex: 1 }}>
            <Title order={2} c="white" mb="md" style={{ fontSize: "clamp(1.75rem, 4vw, 2.5rem)", fontWeight: 900 }}>
              מוכן להתחיל?
            </Title>
            <Text c="rgba(255,255,255,0.9)" mb="xl" size="lg" maw={520} mx="auto">
              14 ימי ניסיון חינם — , ללא התחייבות
            </Text>
            <Group justify="center" gap="md" wrap="wrap">
              <Button
                component="a"
                href="https://app.quicktor.co.il/MainPageToConnect/MainPage"
                size="xl"
                radius="xl"
                style={{
                  background: "white",
                  color: "#764ba2",
                  fontWeight: 800,
                  boxShadow: "0 8px 30px rgba(0,0,0,0.15)",
                }}
              >
                התחל בחינם עכשיו
              </Button>
              <Button
                component="a"
                href="https://wa.me/972557259188?text=שלום, אשמח לשמוע על QuickTor"
                target="_blank"
                rel="noopener noreferrer"
                size="xl"
                radius="xl"
                variant="outline"
                leftSection={<IconBrandWhatsapp size={20} />}
                style={{ borderColor: "rgba(255,255,255,0.6)", color: "white" }}
              >
                דברו איתנו
              </Button>
            </Group>
            <Group justify="center" mt="xl" gap="xl" wrap="wrap">
              {[
                { href: "/managing-queues-hair-salons", label: "ניהול תורים למספרות" },
                { href: "/queue-management-beauticians", label: "ניהול תורים לקוסמטיקאיות" },
                { href: "/queue-management-nail-techs", label: "ניהול תורים לנייליסטיות" },
              ].map((l) => (
                <Link
                  key={l.href}
                  href={l.href}
                  style={{
                    color: "rgba(255,255,255,0.8)",
                    fontSize: "0.875rem",
                    textDecoration: "underline",
                    textDecorationColor: "rgba(255,255,255,0.4)",
                  }}
                >
                  {l.label}
                </Link>
              ))}
            </Group>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export async function getStaticProps() {
  return { props: {} };
}
